module.exports = {
          srcSet: __webpack_public_path__ + "public/images/ea9d7197eb20d863dc1b418878fb2a21-380.webp"+" 380w",
          images:[ {path: __webpack_public_path__ + "public/images/ea9d7197eb20d863dc1b418878fb2a21-380.webp",width: 380,height: 253}],
          src: __webpack_public_path__ + "public/images/ea9d7197eb20d863dc1b418878fb2a21-380.webp",
          toString:function(){return __webpack_public_path__ + "public/images/ea9d7197eb20d863dc1b418878fb2a21-380.webp"},
          
          width: 380,
          height: 253
        }